<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <circle class="a" cx="12" cy="14.25" r="9" />

        <line class="a" x1="18" y1="7.5" x2="19.875" y2="5.625" />

        <line class="a" x1="19.5" y1="5.25" x2="20.25" y2="6" />

        <line class="a" x1="12" y1="5.25" x2="12" y2="0.75" />

        <line class="a" x1="14.25" y1="0.75" x2="9.75" y2="0.75" />

        <line class="a" x1="12" y1="15" x2="8.25" y2="10.849" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'StopwatchIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
